import React from 'react';
import { InfoHintType } from '../../info-hint/info-hint.props';
import InfoHint from '../../info-hint/info-hint-view';

const MaxConfigurationsHint = () => {
  return (
    <InfoHint type={InfoHintType.Warning}>
      Leider kann die Konfiguration nicht gespeichert werden, da die maximale Anzahl für diesen Fahrer überschritten
      wurde. Bitte wähle einen anderen Fahrer oder versuche es später erneut, nachdem frühere Konfigurationen archiviert
      wurden.
    </InfoHint>
  );
};

export default MaxConfigurationsHint;
